module.exports = __webpack_public_path__ + "img/robot-service-engineer.7d8fb20d.png";